
(function() {
  var result = { translations: { "el": { "i18n": { "duration": { "seconds": "{{ seconds }} \u03B4\u03B5\u03C5\u03C4.", "minutes": "{{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "hours": "{{ hours }} \u03CE\u03C1.", "hoursAndMinutes": "{{ hours }} \u03CE\u03C1. {{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "days": "{{ days }} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2", "shortForm": { "seconds": "{{ seconds }}\u03B4.", "minutes": "{{ minutes }}\u03BB.", "hours": "{{ hours }}\u03CE\u03C1.", "days": "{{ days }}\u03B7\u03BC.", "hoursAndMinutes": "{{ hours }}\u03CE\u03C1. {{ minutes }}\u03BB." } }, "dateTime": { "quarterAndYear": "{{quarterNumber}}\u03BF \u03C4\u03C1\u03AF\u03BC. {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u03B5\u03C3\u03C9\u03C4. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "el": "static-7.818"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.818",
    "ar-eg": "static-7.818",
    "bg": "static-7.818",
    "bn": "static-7.818",
    "ca-es": "static-7.818",
    "cs": "static-7.818",
    "da": "static-7.818",
    "de": "static-7.818",
    "el": "static-7.818",
    "en-gb": "static-7.818",
    "en": "static-7.818",
    "es-mx": "static-7.818",
    "es": "static-7.818",
    "fi": "static-7.818",
    "fr-ca": "static-7.818",
    "fr": "static-7.818",
    "he-il": "static-7.818",
    "hr": "static-7.818",
    "hu": "static-7.818",
    "id": "static-7.818",
    "it": "static-7.818",
    "ja": "static-7.818",
    "ko": "static-7.818",
    "lt": "static-7.818",
    "ms": "static-7.818",
    "nl": "static-7.818",
    "no": "static-7.818",
    "pl": "static-7.818",
    "pt-br": "static-7.818",
    "pt-pt": "static-7.818",
    "ro": "static-7.818",
    "ru": "static-7.818",
    "sk": "static-7.818",
    "sl": "static-7.818",
    "sv": "static-7.818",
    "th": "static-7.818",
    "tl": "static-7.818",
    "tr": "static-7.818",
    "uk": "static-7.818",
    "vi": "static-7.818",
    "x-pseudo": "static-7.818",
    "zh-cn": "static-7.818",
    "zh-hk": "static-7.818",
    "zh-tw": "static-7.818"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:el', {version: 'static-7.818'}); }
})();


